import cn from 'classnames';
import React from 'react';

import appConfig from '../../../config/appConfig';
import Footer from './Footer';
import HealthWarning from './HealthWarning';

const AppFooter = (props) => {
    const {className} = props;

    return (
        <div className={cn('w-full', className)}>
            <HealthWarning />
            {appConfig.getIsMarketInitialized() && <Footer />}
        </div>
    );
};

export default AppFooter;
